export default function UserCtrl($scope, UserService, settings, $http) {
  let vm = this;

  UserService.subject.subscribe(function (user) {
    $scope.$applyAsync(function () {
      vm.loggedIn = true;
      vm.user = user;
    });
  });

  vm.logout = UserService.logout;
}
